import Link from "next/link";
import { Button } from "@/components/ui/button";

interface NavbarProps {
  scrollToSection: (e: React.MouseEvent<HTMLAnchorElement>, id: string) => void;
}

export function Navbar({ scrollToSection }: NavbarProps) {
  return (
    <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-md z-50 border-b">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Link href="/" className="text-xl font-bold text-foreground">
              Heroad VTC
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#features"
              onClick={(e) => scrollToSection(e, 'features')}
              className="text-sm font-medium text-foreground hover:underline"
            >
              Fonctionnalités
            </a>
            <a
              href="#pricing"
              onClick={(e) => scrollToSection(e, 'pricing')}
              className="text-sm font-medium text-foreground hover:underline"
            >
              Tarifs
            </a>
            <a
              href="#contact"
              onClick={(e) => scrollToSection(e, 'contact')}
              className="text-sm font-medium text-foreground hover:underline"
            >
              Contact
            </a>
          </div>

          <div className="flex items-center space-x-4">
            <Link href="/login">
              <Button variant="outline">Se connecter</Button>
            </Link>
            <a
              href="#contact"
              onClick={(e) => scrollToSection(e, 'contact')}
            >
              <Button className="bg-foreground hidden md:flex px-4 py-4 text-sm font-semibold text-white shadow-sm hover:bg-muted-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-foreground transition-all duration-200 ease-in-out transform hover:scale-105">Nous contacter</Button>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
